module.exports = __webpack_public_path__ + "static/media/back-btn-hover.7738407f.png";